var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { getLCP, getFID, getCLS, getTTFB, getFCP } from 'web-vitals';
import { isBlank } from '@autobest-ui/utils';
import collectInfo from './collectInfo';
export default function setPerformance(trackPerformance, minFid, minLcp, minCls) {
  if (minFid === void 0) {
    minFid = 0;
  }
  if (minLcp === void 0) {
    minLcp = 0;
  }
  if (minCls === void 0) {
    minCls = 0;
  }
  if (!window.PerformanceObserver || !window.navigator || !window.navigator.storage || !window.navigator.storage.estimate || !window.navigator.serviceWorker) {
    return;
  }
  // 性能统计
  var performanceParams = {
    response: {}
  };
  var trackId;
  var hasTrackAllInfo = false;
  var callback = function callback(info) {
    performanceParams[info.name] = info.value;
    if (info.desc) {
      performanceParams.response[info.name] = info.desc;
    }
    // 防止重复收集
    if (hasTrackAllInfo) {
      return;
    }
    // 用户操作页面才收集，否则收集的信息没有多少价值
    if (!isBlank(performanceParams.FID) && !isBlank(performanceParams.LCP) && !isBlank(performanceParams.CLS) && (performanceParams.FID > minFid || performanceParams.LCP > minLcp || performanceParams.CLS > minCls)) {
      hasTrackAllInfo = true;
      trackId = trackPerformance(__assign(__assign({}, performanceParams), {
        response: JSON.stringify(performanceParams.response)
      }), trackId);
    }
  };
  getLCP(function (info) {
    return collectInfo.lcp(info, minLcp, callback);
  });
  getFID(function (info) {
    return collectInfo.fid(info, minFid, callback);
  });
  getCLS(function (info) {
    return collectInfo.cls(info, minCls, callback);
  });
  getTTFB(function (info) {
    return collectInfo.ttfb(info, callback);
  });
  getFCP(function (info) {
    return collectInfo.fcp(info, callback);
  });
}